import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBTabPane,
  MDBTabContent,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
} from "mdbreact";

import "../css/scrollbar.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxesPacking } from "@fortawesome/free-solid-svg-icons";

import PackagesCheckerTable from "./PackagesCheckerTable.jsx";

const PackagesChecker = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };

  const [showPreloader, setPreloader] = useState("normal");

  const [rows, setRows] = useState([]);

  const [selRow, setSelectedRow] = useState("");

  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = () => {
    showAddEdit(!modalAddEdit);
    loadData();
  };

  const [bRefresh, setRefresh] = useState(false);
  function refreshGrid() {
    setRefresh(!bRefresh);
    loadData();
  }

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function loadData() {
    Axios.get(props.apiServer + "/packageslist", bearer)
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function loadDeleteItems() {
    Axios.get(props.apiServer + "/deletedpackageslist", bearer)
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const [activeTab, setActiveTab] = useState("1");
  const toggleClassicTabs3 = (x) => {
    if (x === "1") {
      loadData();
    } else if (x === "2") {
      loadDeleteItems();
    } else {
      loadData();
    }
    setActiveTab(x);
  };

  const useMountEffect = (functionName) => useEffect(functionName, []);

  useMountEffect(loadData);

  const TabItems = (x) => {
    return (
      <React.Fragment>
        <MDBNav
          classicTabs
          className="mt-5 cloudy-knoxville-gradient brown-text small"
        >
          <MDBNavItem>
            <MDBNavLink
              to="#"
              active={activeTab === "1"}
              onClick={() => toggleClassicTabs3("1")}
              className="brown-text"
            >
              {/* <MDBIcon
                // fas
                icon="shopping-cart"
                size="2x"
                className="brown-text"
              /> */}
              <FontAwesomeIcon
                icon={faBoxesPacking}
                size="2x"
                className="brown-text"
              />
              <br />
              <br />
              <b>Active Packages</b>
            </MDBNavLink>
          </MDBNavItem>
        </MDBNav>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <MDBRow className="pt-5 pb-0 mb-0">
        <MDBCol md="12">
          <h6
            style={{ fontFamily: "Montserrat", fontWeight: "400" }}
            className="display-5 blue-grey-text ml-1"
          >
            {" "}
            <FontAwesomeIcon
              icon={faBoxesPacking}
              size="3x"
              // className="brown-text"
            />{" "}
            Packages
          </h6>
        </MDBCol>
      </MDBRow>

      <div className="classic-tabs">
        <TabItems />

        <MDBTabContent
          className="card mb-5 pt-0 pl-0 pr-0 pb-0"
          activeItem={activeTab}
        >
          <MDBTabPane tabId="1">
            {showPreloader === "normal" ? (
              <MDBRow>
                <MDBCol md="4"></MDBCol>
                <MDBCol md="4" className="text-center">
                  <br />
                  <img
                    src={process.env.PUBLIC_URL + "/loading.gif"}
                    style={{ width: "300px", textAlign: "center" }}
                    alt="loading"
                  />
                  <br />
                </MDBCol>
                <MDBCol md="4"></MDBCol>
              </MDBRow>
            ) : (
              <PackagesCheckerTable
                rows={rows}
                loadData={loadData}
                apiServer={props.apiServer}
                apiServerHybrid={props.apiServerHybrid}
                title="Active Packages"
                toggleModal={toggleAddEdit}
                refreshGrid={refreshGrid}
                description="List of Active Packages"
              />
            )}
          </MDBTabPane>

          <MDBTabPane tabId="2">
            {showPreloader === "normal" ? (
              <MDBRow>
                <MDBCol md="4"></MDBCol>
                <MDBCol md="4" className="text-center">
                  <br />
                  <img
                    src={process.env.PUBLIC_URL + "/loading.gif"}
                    style={{ width: "300px", textAlign: "center" }}
                    alt="loading"
                  />
                  <br />
                </MDBCol>
                <MDBCol md="4"></MDBCol>
              </MDBRow>
            ) : (
              <PackagesCheckerTable
                rows={rows}
                loadData={loadDeleteItems}
                apiServer={props.apiServer}
                apiServerHybrid={props.apiServerHybrid}
                title="Deleted Packages"
                toggleModal={toggleAddEdit}
                refreshGrid={refreshGrid}
                description="List of deleted packages"
              />
            )}
          </MDBTabPane>
        </MDBTabContent>
      </div>
    </React.Fragment>
  );
};

export default PackagesChecker;
